
<tilby-dialog-toolbar [hideConfirm]="true" [hideCancel]="!canDismiss">
    <div class="tw-relative tw-flex tw-items-center tw-justify-center tw-w-full" [ngClass]="canDismiss ? 'tw-mr-12' : 'tw-mr-3'" toolbar-content>
    <img src="assets/images/tilby/logo.png" class="tw-h-10" alt="tilby_logo"/>
    @if(showBackButton) {
        <div class="tw-flex tw-items-center tw-cursor-pointer tw-py-4" style="position: absolute; top: 50%; transform: translate(-50%, -50%);" [ngStyle]="{'right': canDismiss ? '-35px' : '0'}" (click)="changeView('badge')">
            <mat-icon fontSet="material-symbols-outlined">arrow_left_alt</mat-icon>
        </div>
    }
</div>
</tilby-dialog-toolbar>
<tilby-dialog-content>
    <div class="tw-flex" [ngClass]="{'tw-justify-around': hideUsers, 'tw-justify-between': !hideUsers }">
        @if(showLoginFromBadge) {
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-flex-1 tw-text-center" style="max-width: 252px; height: 330px; overflow-y: hidden; ">
                <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
                    <p class="tw-text-lg tw-font-medium tw-text-gray-800 tw-m-0">
                        @if(canDismiss) {
                            <span class="tw-font-semibold">{{"DIALOG.USER_SESSIONS_MANAGER.AUTH_WITH_CARD" | translate}}</span>
                        } @else {
                            <span class="tw-font-semibold">{{"DIALOG.USER_SESSIONS_MANAGER.LOGIN_WITH_CARD" | translate}}</span>
                        }
                    </p>
                    <div class="tw-flex tw-justify-center">
                        <img src="assets/images/tilby/badge.png" class="tw-h-[25vh] tw-max-h-[140px] tw-w-auto tw-object-contain" alt="Badge">
                    </div>
                </div>

                @if(!data.activeUser || data.activeUser.pin) {
                    <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-cursor-pointer tw-py-4" (click)="changeView('pin')">
                        <mat-icon>arrow_right_alt</mat-icon>
                        <span class="tw-font-semibold">{{"DIALOG.USER_SESSIONS_MANAGER.LOGIN_WITH_PIN" | translate}}</span>
                    </div>
                }
            </div>
        } @else {
            @if(!hideUsers) {
                <section class="users-sessions-manager-list-section mobile-section" [ngClass]="{'tw-w-1/2': openPinKeypad, 'tw-w-full': !openPinKeypad}" style="max-width: 252px; height: 330px; overflow-y: hidden;">
                    <div class="tw-h-[46px] tw-pb-[4px]">
                        <div class="tw-h-[46px] tw-flex tw-justify-end">
                            @if(openFilter){
                                <div>
                                    <mat-form-field class="tw-h-[46px]" [ngClass]="{'tw-max-w-[189px]' : openPinKeypad && showNewUser(), 'tw-max-w-[205px]': !openPinKeypad && showNewUser(), 'tw-max-w-[228px]': openPinKeypad && !showNewUser()}" subscriptSizing="dynamic">
                                        <mat-label>{{"DIALOG.USER_SESSIONS_MANAGER.FILTER" | translate}}</mat-label>
                                        <input matInput id="userFilterInput" type="text" [(ngModel)]="userFilter" (input)="onFilterChange($event)" cdkFocusInitial>
                                        <button mat-icon-button matSuffix style="top: -4px" (click)="clearUserFilter()">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </mat-form-field>
                                </div>
                            }
                            <div class="tw-flex tw-gap-2 tw-items-center">
                                @if(!openFilter){
                                    <div class="tw-flex tw-items-center tw-h-full">
                                        <button class="buttons tw-h-full" (click)="userFilterOpen()">
                                            <mat-icon class="tw-m-0" style="transform: scale(1.4);">filter_list</mat-icon>
                                        </button>
                                    </div>
                                }
                                @if(showNewUser()){
                                    <div class="tw-flex tw-items-center tw-h-full">
                                        <button class="buttons tw-h-full" (click)="newLogin()">
                                            <mat-icon class="tw-m-0" style="transform: scale(1.4);">add</mat-icon>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div class='tw-h-[17.4rem]'>
                        <cdk-virtual-scroll-viewport appendOnly itemSize="50" class="tw-h-full">
                            <div *cdkVirtualFor="let user of usersFiltered">
                                <div class="tw-flex tw-items-center tw-gap-4 tw-mb-2" (click)="selectUserSession(user)" [ngClass]="{ 'selected': userSelected === user, 'dark-theme': themeMode.isDarkTheme()}">
                                    @if(user.thumbnail){
                                        <img src="{{user.thumbnail}}" class="users-sessions-manager-user-thumbnail" alt="{{user.username}}">
                                    }
                                    @if(!user.thumbnail){   
                                        <div class="tw-mt-2 tw-ml-4">
                                            <mat-icon style="color:gray; transform: scale(2)">account_circle</mat-icon>
                                        </div>
                                    }
                                    <div class="tw-flex tw-flex-col" style="white-space: nowrap;">
                                        <div>
                                            {{ user.first_name | uppercaseFirstLetter }} {{ user.last_name | uppercaseFirstLetter}}
                                        </div>
                                        <div>
                                            {{ user.username }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </cdk-virtual-scroll-viewport>
                    </div>
                </section>
            }

            @if(this.userSelected?.pin) {
                <section class="users-sessions-manager-pin-section mobile-section" [ngClass]="{'tw-w-1/2': !hideUsers, 'tw-w-full': hideUsers}">
                    <div class="pin-container tw-h-fit tw-pb-[22px] tw-px-5">
                        @for(digit of pinDigitClass; track digit) {
                            <div [ngClass]="digit" class="circle-pin"></div>
                        }
                    </div>
                    <keypad-pin class="tw-flex tw-justify-around" field="pincode" maxlength="4" (digitChange)="onDigitChange($event)" [blockKeypad]="blockPinKeypad"></keypad-pin>
                </section>
            }
        }
    </div>
    <div class="tw-flex tw-justify-center tw-mt-2.5">
        <img src="assets/images/tilby/Zuc_Orizz_B.svg" class="tw-h-7" alt="Logo Zucchetti">
    </div>
</tilby-dialog-content>